import type { ReactNode } from 'react';

export const symbol_dishwasher: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-560v380h600v-380H180Zm0-60h600v-160H180v160Zm299.91 353q-28.91 0-49.41-20.56Q410-308.13 410-337q0-14 4.5-28.5T428-397q9-17 19.05-31.97 10.04-14.97 20.93-29.94Q473-466 480-466t12.02 7.09q10.89 14.97 20.93 29.94Q523-414 532-397t13.5 31.5Q550-351 550-337q0 28.87-20.59 49.44Q508.82-267 479.91-267ZM721-679q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-500v-160 160Z"
		/>
	</svg>
);
